import Storage from '../types/locStorage';

const storage = {
    // Set new item in local storage
    set: (key: Storage, data: any) => {
        // Convert item object to JSON
        const str = JSON.stringify(data);
        // Base-64 encode JSON string
        const enc = btoa(str);
        // Store encoded string as key in local storage
        localStorage.setItem(key, enc);
    },
    // Get item in local storage
    get: (key: Storage): any | null => {
        // Get item by key
        const raw = localStorage.getItem(key);
        // If no data return null
        if (!raw) return null;
        // Decode string
        const dec = atob(raw);
        // Parse decoded string to javascript
        const data = JSON.parse(dec);
        // Return javascript object
        return data;
    },
    // Clear all local storage keys and data
    clear: () => localStorage.clear(),
};

export default storage;
